import React from "react";
import UserInfo from "../../../Components/UserInfo/UserInfo";
import styles from "./allTalentOffers.module.css";
import Offer from "../../../../../Assets/svgs/offer.svg";
import { useEffect, useState } from "react";
import { Axios } from "../../../../../Api/Axios";
import {
  ALLTALENTOFFERS,
  REVIEWS,
  USER,
  USERS,
} from "../../../../../Api/Api";
import { ThreeDots } from "react-loader-spinner";
import ShowModalOffer from "../../../Components/ShowModalOffer/ShowModalOffer";

const AllTalentOffers = () => {
  const [userData, setUserData] = useState("");
  const [loading, setLoading] = useState(true);
  const [rate, setRate] = useState(0);
  const [allOffers, setAllOffers] = useState([]);
  const [showModalOffer, setShowModalOffer] = useState({
    status: false,
    offerData: null,
  });

  const defaultProfileImage = require("../../../../../Assets/Images/profile.jpg");
  const [profileImage, setProfileImage] = useState(defaultProfileImage);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await Axios.get(`${USER}`);
        const user = res.data;
        setUserData(user);

        const picture = user.profilePicture;
        if (picture && picture.trim() !== "") {
          const decodedImage = `data:image/jpeg;base64,${picture}`;
          setProfileImage(decodedImage);
        } else {
          setProfileImage(defaultProfileImage);
        }

        const resReviews = await Axios.get(`${USERS}/${user.id}/${REVIEWS}`);
        setRate(resReviews.data.average_rating);
        const allOffers = await Axios.get(`${ALLTALENTOFFERS}`);
        setAllOffers(allOffers.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // console.log(allOffers);

  const mapAllOffers = allOffers.map((offer) => {
    const decodedImage = `data:image/jpeg;base64,${offer.investor.profilePicture}`;
    return (
      <div key={offer.id} className={`${styles.card} card shadow-lg mb-4`}>
        <div
          className={`${styles.cardBody} card-body d-flex align-items-center justify-content-between gap-5 p-relative`}
        >
          <div style={{ width: "100%" }}>
            <div>
              <div className="d-flex align-items-center gap-4">
                <img
                  width={80}
                  height={80}
                  src={decodedImage ? decodedImage : defaultProfileImage}
                  alt="profile"
                  style={{ borderRadius: "50%", objectFit: "contain" }}
                />
                <span style={{ color: "#3d3d3d" }}>{offer.investor.name}</span>
                <span
                  className={`badge m-0 ${
                    offer.status === "pendingAdminApproval"
                      ? "text-bg-warning"
                      : offer.status === "adminAccepted"
                      ? "text-bg-success"
                      : offer.status === "adminRejected"
                      ? "text-bg-danger"
                      : offer.status === "talentRejected"
                      ? "text-bg-danger"
                      : "text-bg-primary"
                  }`}
                >
                  {offer.status === "pendingAdminApproval"
                    ? "Offer Pending By Admin"
                    : offer.status === "adminAccepted"
                    ? "Offer Accepted By Admin"
                    : offer.status === "adminRejected"
                    ? "Offer Rejected By Admin"
                    : offer.status === "talentRejected"
                    ? "Offer Rejected By Me"
                    : "I Accepted"}
                </span>
              </div>
            </div>
          </div>

          <button
            onClick={() =>
              setShowModalOffer({ status: true, offerData: offer })
            }
          >
            <img src={Offer} alt="Offer" style={{ objectFit: "contain" }} />
          </button>
        </div>
      </div>
    );
  });

  // const mapAllOffers = allOffers.map((offer) => (
  //   <tr key={offer.id}>
  //     <td>
  //       <div className="d-flex align-items-center gap-2">
  //         <img
  //           src={
  //             offer.investor.profilePicture
  //               ? `data:image/jpeg;base64,${offer.investor.profilePicture}`
  //               : defaultProfileImage
  //           }
  //           alt="investor"
  //           className="rounded-circle me-2"
  //           style={{ width: "40px", height: "40px", objectFit: "cover" }}
  //         />
  //         {/* <div style={{ fontSize: "20px" }}>
  //           <FontAwesomeIcon icon={faUser} />
  //         </div> */}
  //         <span>{offer.title}</span>
  //       </div>
  //     </td>

  //     <td>${offer.amount}/month</td>
  //     <td
  //       style={{
  //         maxWidth: "200px",
  //         whiteSpace: "normal",
  //         wordWrap: "break-word",
  //       }}
  //     >
  //       {offer.notes}
  //     </td>
  //     <td>
  //       <span
  //         className={`badge m-0 ${
  //           offer.status === "pendingAdminApproval"
  //             ? "text-bg-warning"
  //             : offer.status === "adminAccepted"
  //             ? "text-bg-success"
  //             : offer.status === "adminRejected"
  //             ? "text-bg-danger"
  //             : offer.status === "talentRejected"
  //             ? "text-bg-danger"
  //             : "text-bg-primary"
  //         }`}
  //       >
  //         {offer.status === "pendingAdminApproval"
  //           ? "Offer Pending By Admin"
  //           : offer.status === "adminAccepted"
  //           ? "Offer Accepted By Admin"
  //           : offer.status === "adminRejected"
  //           ? "Offer Rejected By Admin"
  //           : offer.status === "talentRejected"
  //           ? "Offer Rejected By Me"
  //           : "I Accepted"}
  //       </span>
  //     </td>
  //   </tr>
  // ));

  return (
    <>
      <UserInfo rate={rate} />
      <hr style={{ width: "20%" }} />
      {/* Card Certificates */}
      {loading ? (
        <ThreeDots
          visible={true}
          height="60"
          width="60"
          color="#7939FF"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      ) : (
        <div className={`${styles.second} shadow-lg p-4`}>
          <h2>My Offers</h2>
          {mapAllOffers}
          {showModalOffer.status && (
            <ShowModalOffer
              isOpen={showModalOffer.status}
              onClose={() =>
                setShowModalOffer({ status: false, offerData: null })
              }
              offerData={showModalOffer.offerData}
            />
          )}
        </div>
      )}
    </>
  );
};

export default AllTalentOffers;
